module.exports = __webpack_public_path__ + "img/info3.27cec132.png";